import { isEmpty } from 'lodash';

import { SpotRateModel } from '../types';

export const getMinRate = (rates: SpotRateModel[]): SpotRateModel | undefined => {
  if (isEmpty(rates)) return undefined;

  // Find the rate with the lowest min price
  const rateWithLowestMin = rates.reduce((prev, curr) => {
    return curr.pricing.value! < prev.pricing.value! ? curr : prev;
  });

  return rateWithLowestMin;
};
